
/**
 * Retrieves selected locations from localStorage and enhances them with duration info
 */
export const getLocationsWithDuration = (duration: number, budgetInfo: any) => {
  const selectedLocationsString = localStorage.getItem('selectedLocations') || '[]';
  const selectedLocations = JSON.parse(selectedLocationsString);
  
  // Add duration to each location for accurate calculations in the edge function
  const locationsWithDuration = selectedLocations.map((loc: any) => ({
    ...loc,
    duration,
    budgetCalculations: budgetInfo // Add budget calculations to each location
  }));
  
  console.log(`Retrieved ${locationsWithDuration.length} locations`);
  return locationsWithDuration;
};
